<!---------- UNLOGGED USER FORM ---------->
<app-form-login *ngIf="!logged" [smallTitle]="'COMMON.REGISTER_TO_CONTINUE'"></app-form-login>

<div *ngIf="logged" class="w-100 d-flex flex-column mt-4">

  <form *ngIf="user" [formGroup]="userForm" [ngClass]="{'mb-5 pb-5': isMobile}"
        class="d-flex flex-row flex-wrap form_container no-transform">
    <h2 class="title_2 w-100 mb-3">{{ 'HEADER.MY_ACCOUNT' | translate }}</h2>

    <div class="col-6 m-0 pe-4">
      <mat-form-field (keyup)="checkLatin('firstname',$event)" class="pb-0 w-100 ">
        <mat-label class="text-black subtitle_1">{{ "PROFILE.FIRSTNAME" | translate }}</mat-label>
        <input [formControl]='userForm.controls.firstname' class="text_3" formControlName="firstname" matInput
          type="text"
          value="{{user.firstname}}">
      </mat-form-field>
      <div *ngIf="errors.firstname" class="text-danger minitext_2">
        {{errors.firstname }}
      </div>
    </div>

    <div class="col-6 m-0 ps-4">
      <mat-form-field (keyup)="checkLatin('lastname',$event)" class="pb-0 w-100 ">
        <mat-label class="text-black subtitle_1">{{ "PROFILE.LASTNAME" | translate }}</mat-label>
        <input [formControl]='userForm.controls.lastname' class="text_3" formControlName="lastname" matInput
          type="text"
          value="{{user.lastname}}">
      </mat-form-field>
      <div *ngIf="errors.lastname" class="text-danger minitext_2">
        {{errors.lastname}}
      </div>
    </div>

    <div class="w-100 mt-4 mb-2">
      <mat-select-country (onCountrySelected)="onCountrySelected($event)" [countries]="predefinedCountries"
        [formControl]="userForm.controls.nationality"
        [value]="userForm.controls.nationality.value"
        [ngClass]="{ 'is-invalid': isFormSubmitted && userForm.controls.nationality.errors }"
        class="w-100 pb-0 "
        label="{{'PROFILE.NATIONALITY' | translate}}"
        placeHolder="{{'PROFILE.NATIONALITY' | translate}}"
        required>
      </mat-select-country>
      <span *ngIf="isFormSubmitted && userForm.controls.nationality.errors" class="text-danger minitext_2">
        {{ "COMMON.IS_REQUIRED" | translate }}
      </span>
    </div>


    <mat-form-field class="col-12 pb-0 mt-2 mb-2">
      <mat-label class="text-black subtitle_1">{{ "COMMON.USER.EMAIL" | translate }}</mat-label>
      <input class="text_3" disabled matInput type="text" value="{{user.email}}">
    </mat-form-field>

    <div class="position-relative w-100 mt-4">
      <span [ngClass]="{'isMobile': isMobile}"
        class="subtitle_1 text-black rescale form-label-color">{{ "PROFILE.PHONE" | translate }} *</span>
      <ngx-intl-tel-input [enableAutoCountrySelect]="true"
        [enablePlaceholder]="true"
        [formControl]="userForm.controls.phone"
        [maxLength]="'20'"
        [ngClass]="{ 'is-invalid': isFormSubmitted && userForm.controls.phone.errors }"
        [phoneValidation]="true"
        [selectFirstCountry]="false"
        [separateDialCode]="true"
                          class="ngx-intl-tel_mat-form-style subtitle_2"
                          formControl="phone"
                          formControlName="phone">
      </ngx-intl-tel-input>
      <span *ngIf="isFormSubmitted && userForm.controls.phone.errors" class="text-danger minitext_2">
        {{ "COMMON.IS_REQUIRED" | translate }}
      </span>
    </div>

    <h2 class="title_2 w-100 mb-4 mt-5">{{ "PROFILE.TITLE" | translate }}</h2>

    <div class="w-100 mb-3">
      <div class="mb-3 position-relative">
         <span [ngClass]="{'text-danger': !isBirthdayCorrect || (isFormSubmitted && fUser.birthdate.invalid)}"
           class="subtitle_1 rescale form-label-color text-black birthdate_label">
        {{ "PROFILE.BIRTHDATE" | translate }}
      </span>
        <div *ngIf="!isBirthdayCorrect" class="text-danger minitext_2">
          {{ 'COMMON.BIRTHDATE_FORMAT.INVALIDE' | translate }}
        </div>
      </div>

      <app-birthdate-divided #birthdayInputs (newBirthdate)="getBirthdate($event)" [birthdate]="user.birthdate"
                             [ngClass]="{'is-invalid': !isBirthdayCorrect || (isFormSubmitted && fUser.birthdate.invalid)}"
                             [type]="'birthdate'"
                             class="subtitle_2"></app-birthdate-divided>
    </div>
    <div class="position-relative w-100">
      <app-city-input #cityInput (onChange)="setCity($event)" (onManualChange)="changeManualInput()" [cityControl]="fUser.birthplace"
                      [floatLabel]="'always'" [labelContent]="'COMMON.USER.PLACEOFBIRTH' | translate"
                      [user]="user"
                      [wantedField]="'birthplace'" class="pb-0"></app-city-input>
      <div *ngIf="!fUser.birthplace.errors"
           class="position-absolute text-success d-flex align-items-center font-12 pt-4">
        <span class="material-icons-outlined font-12 me-1">done</span>
        {{ 'COMMON.OK_CHECKED' | translate }}
      </div>

      <div *ngIf="errors.birthplace" class="text-danger" style="margin-bottom: 5px;">
        {{errors.birthplace}}
      </div>
    </div>

    <app-address-input #addressInput (formattedAddress)="getAddress($event, 'address')"
                       (getAdditionalAddress)="getAddress($event, 'add')"
                       [address2FormControl]="additionalAddressFormControl" [addressControl]="fUser.address"
                       [needFormattedAddress]="true"
                       [ngClass]="{'is-invalid': isFormSubmitted && (userForm && !userForm.value.address)}"
                       [placeholder]="'COMMON.RESIDENCE_ADDRESS'"
                       adressType="address"
                       class="w-100"
                       id="address"></app-address-input>


    <!---------- DOCUMENT FORM ---------->
    <h2 class="text-black title_2 w-100 mb-2">{{ "COMMON.RESERVATION_DOCUMENT.TITLE" | translate }}</h2>
    <div class="w-100">
      <div class="doc_title d-flex flex-column">
           <span [ngClass]="isFormSubmitted && fUser.ID_PHOTO.errors ? 'text-danger' : ''"
                 class="label subtitle_1">
              {{ "COMMON.USER.ID_FILE" | translate }}
           </span>
        <span *ngIf="isFormSubmitted && fUser.ID_PHOTO.errors && fUser.ID_PHOTO.errors.required"
              class="text-danger minitext_2">
            {{ "COMMON.IS_REQUIRED" | translate }}
          </span>
      </div>
      <app-upload-file (onDelete)="onFileDelete($event)" (onUpload)="onFileUpload($event)" [documentType]="'ID_PHOTO'"
                       [mode]="'single'" class="w-100"></app-upload-file>
    </div>


    <div class="w-100 mt-3">
      <div class="doc_title d-flex flex-column">
          <span [ngClass]="isFormSubmitted && fUser.LETTRE_D_ADMISSION.errors ? 'text-danger' : ''"
            class="label subtitle_1">
            {{ "COMMON.USER.ACCEPTANCE_LETTER" | translate }}
          </span>
        <span *ngIf="isFormSubmitted && fUser.LETTRE_D_ADMISSION.errors && fUser.LETTRE_D_ADMISSION.errors.required"
          class="text-danger minitext_2">
            {{ "COMMON.IS_REQUIRED" | translate }}
          </span>
      </div>
      <app-upload-file (onDelete)="onFileDelete($event)" (onUpload)="onFileUpload($event)"
                       [documentType]="'LETTRE_D_ADMISSION'"
                       [mode]="'single'" class="w-100"></app-upload-file>
      <div class="d-flex gap-8 align-items-center mt-4">
        <lf-icon height="24px" name="padlockGreen" width="24px"></lf-icon>
        <p class="text_1">{{ "COMMON.DOCUMENT_REASSURANCE" | translate }}</p>
      </div>

    </div>

      <mat-form-field class="mt-5 w-100" *ngIf="!user.school || (user.school && user.school.slug === 'livinfrance')">
        <mat-label>{{'COMMON.WICH_SCHOOL.QUESTION' | translate }}</mat-label>
        <input type="text" matInput formControlName="school_name" />
      </mat-form-field>

    <h2 class="text-black title_2 w-100 mb-0 mt-5">{{'COMMON.DISCOVER_US.QUESTION' | translate }}</h2>

    <div class="w-100">
      <mat-form-field class="w-100">
        <mat-select formControlName="discoverUs" panelClass="smaller">
          <mat-option [value]="''" class="text_1">{{ 'COMMON.DISCOVER_US.NONE' | translate }}</mat-option>
          <mat-optgroup *ngFor="let group of discoverOptions"
            [label]="('COMMON.DISCOVER_US.' + group.name + '.TITLE') | translate">
            <mat-option *ngFor="let option of group.values" class="text_1"
              [value]="'COMMON.DISCOVER_US.' + group.name + '.REASON_' +option">{{ ("COMMON.DISCOVER_US." + group.name + ".REASON_" + option) | translate}}</mat-option>
          </mat-optgroup>
          <mat-option [value]="'COMMON.DISCOVER_US.OTHER'"
            class="text_1">{{ 'COMMON.DISCOVER_US.OTHER' | translate }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field *ngIf="this.userForm.value['discoverUs'] == 'COMMON.DISCOVER_US.OTHER'"
        class="w-100 mt-2">
        <mat-label class="subtitle_1 text-black">{{ "COMMON.DISCOVER_US.MORE" | translate }}</mat-label>
        <input class="text_3" formControlName="discoverUsMore" matInput maxlength="1024" type="text">
      </mat-form-field>
    </div>


    <div [ngClass]="isMobile ? 'position-fixed px-3 py-3 gap-16' : 'w-100'" class="d-flex mt-3">
      <div *ngIf="isMobile" class="d-flex gap-8 align-items-center">
        <lf-icon height="24px" name="livinGarantGray" width="24px"></lf-icon>
        <p class="text_3"> {{ "FAQS.ACCOMMODATION.CAT.GARANTNEEDED.FIELDS.01" | translate }}</p>
      </div>

      <button (click)="submit()" [disabled]="isFetching"
              checkFormError class="btn fw-bold text-white d-flex align-items-center ms-auto gap-8" type="submit">
        {{ 'COMMON.NEXT' | translate }}
        <span *ngIf="isFetching" class="spinner-border spinner-border-sm v-middle"></span>
        <lf-icon *ngIf="!isFetching" height="12px" name="rightChevron" width="12px"></lf-icon>
      </button>
    </div>

  </form>

</div>
